// MobileForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Input from '../../../common/form/input/input.jsx'
import Select from '../../../common/form/select/select.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Tab from '../../../common/layout/tab/tab.jsx'
import TabPanel from '../../../common/layout/tab_panel/tab_panel.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class MobileForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      projectId: null,
      activityId: null,
      activity: '',
      time: 0,
      timeText: '0:00',
      description: ''
    }

    this.data = {
      projects: _.cloneDeep(props.projects),
      normalActivities: [
        { label: 'time.form.activityHoliday', value: 'Holiday' },
        { label: 'time.form.activitySickLeave', value: 'SickLeave' },
        { label: 'time.form.activityMeeting', value: 'Meeting' },
        { label: 'time.form.activityTraining', value: 'Training' },
        { label: 'time.form.activityDoctorOrDentist', value: 'Doctor/Dentist' },
        { label: 'time.form.activityOther', value: 'Other' }
      ],
      disableSubmit: false
    }

    this._hideMessageTime = null
  }

  static get propTypes () {
    return {
      projects: PropTypes.array,
      timecard: PropTypes.object,
      onSubmit: PropTypes.func,
      onClose: PropTypes.func,
      onSearchActivity: PropTypes.func,
      headerInfo: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      projects: [],
      timecard: null,
      onSubmit: null,
      onClose: null,
      onSearchActivity: null,
      headerInfo: null
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(false, ev)
    } else if (this.state.active && ev.keyCode === 27) {
      this.hide()
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    this.data.projects = _.cloneDeep(nextProps.projects)
  }

  componentWillUnmount () {
    if (this._hideMessageTime) window.clearTimeout(this._hideMessageTime)
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  show (projects) {
    FabButtonManager.setVisible(false)
    if (projects !== undefined && projects) {
      this.data.projects = projects
    }
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      projectId: null,
      activityId: null,
      activity: '',
      timeText: '0:00',
      time: 0,
      description: ''
    })
    this.data.disableSubmit = false
  }

  showMessage (title, info, bSuccess) {
    this.setState({
      message: { title: title, info: info, bSuccess: bSuccess }
    })

    if (this._hideMessageTime) window.clearTimeout(this._hideMessageTime)

    this._hideMessageTime = window.setTimeout(() => {
      this.setState({ message: null })
    }, 2000)
  }

  render () {
    const { projectId, activityId, description } = this.state
    const timeOptions = [
      {
        label: 'time.item.labelFifteenMinutes',
        title: 'time.item.titleAdd15Minutes',
        value: 15
      },
      {
        label: 'time.item.labelThirtyMinutes',
        title: 'time.item.titleAdd30Minutes',
        value: 30
      },
      {
        label: 'time.item.labelOneHour',
        title: 'time.item.titleAddOneHour',
        value: 60
      },
      {
        label: 'time.item.labelTwoHour',
        title: 'time.item.titleAddTwoHour',
        value: 120
      },
      {
        label: 'time.item.labelFourHours',
        title: 'time.item.titleAddFourHours',
        value: 240
      },
      {
        label: 'time.item.labelEightHours',
        title: 'time.item.titleAddEightHours',
        value: 480
      }
    ]
    const _className = classnames('mobile-form', {
      active: this.state.active
    })

    const headerInfo = this.props.headerInfo
    const activeDate = headerInfo.activeDate
    return (
      <div className={_className}>
        <div className='mobileform-header'>
          <div className='titleinfo'>
            <h1 className='hour'>
              <IntlMessage ident='time.form.headerAddHours' />
            </h1>
            <p className='info'>
              {headerInfo.activeDateTime > 0
                ? Util.convertMinutesToTimeText(headerInfo.activeDateTime)
                : '0 hours'}
              <IntlMessage ident='time.form.mobileHeaderInfo' />
              {DateUtil.getDisplayWeekDay(activeDate)},{' '}
              {DateUtil.getDisplayFullMonth(activeDate)} {activeDate.getDate()}
            </p>
          </div>
          <IconButton
            icon='wizard-close'
            className='modal wizard-close'
            canHover={false}
            onClick={this._onClickClose.bind(this)}
          />
          {this.state.message && (
            <div
              className={`formmessage${
                !this.state.message.bSuccess ? ' formmessage_error' : ''
              }`}
            >
              <h2 className='title'>
                <IntlMessage ident={this.state.message.title} />
              </h2>
              <p className='content'>
                <IntlMessage ident={this.state.message.info} />
              </p>
            </div>
          )}
        </div>
        <div className='mobileform-content'>
          <form
            className='form'
            method='post'
            noValidate
            action='#'
            onSubmit={this._onFormSubmit.bind(this)}
          >
            <div className='form-layout'>
              <div className='layoutcol'>
                <div className='formsection'>
                  <div className='formrow'>
                    <Tab showFullBorder>
                      <TabPanel title='time.form.tabProject'>
                        <div className='formrow'>
                          <div className='formcol'>
                            <Select
                              options={this.data.projects}
                              name='project'
                              label='time.form.projectLabel'
                              className='form-dropdown'
                              onChange={this._onChangeProject.bind(this)}
                              value={projectId}
                            />
                          </div>
                        </div>
                        {this.state.projectId && (
                          <div className='formrow'>
                            <div className='formcol'>
                              <Select
                                options={this.data.activities}
                                name='activity'
                                label='time.form.activityLabel'
                                className='form-dropdown'
                                onChange={this._onChangeBudgetItem.bind(this)}
                                value={activityId}
                              />
                            </div>
                          </div>
                        )}
                      </TabPanel>
                      <TabPanel title='time.form.tabOther'>
                        {this._renderOtherActivity()}
                      </TabPanel>
                    </Tab>
                  </div>
                  <div className='formrow'>
                    <div className='activecont'>
                      <div className='actioncol'>
                        <Input
                          type='text'
                          name='time'
                          label='time.item.labelTimeInput'
                          className='timeforminput'
                          value={this.state.timeText}
                          size={10}
                          maxLength={100}
                          validations={['required']}
                          onChange={this._onChangeTimeTaken.bind(this)}
                          onBlur={this._onBlurTimeTaken.bind(this)}
                          onKeyDown={this._onKeyPressInput.bind(this)}
                        />
                        <span className='info'>
                          <IntlMessage ident='time.form.timecardHours' />
                        </span>
                      </div>
                      <div className='timecol'>
                        {timeOptions.map((timeOpt, idx) => (
                          <div
                            title={IntlUtil.convertMessage(timeOpt.title)}
                            className='timebutton'
                            key={idx}
                            onClick={this._onIncrementTime.bind(
                              this,
                              timeOpt.value
                            )}
                          >
                            <IntlMessage ident={timeOpt.label} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='description'
                        label='task.form.descriptionLabel'
                        size={10}
                        maxLength={100}
                        value={description}
                        onChange={this._onChangeInput.bind(this, 'description')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='footer-submit'>
          <IconButton
            type='primary'
            size='big'
            icon='common-saveadd'
            title='time.form.tipSaveAdd'
            className='actsecond'
            canHover={false}
            onClick={
              this.data.disableSubmit
                ? null
                : this._onFormSubmit.bind(this, true)
            }
            disabled={this.data.disableSubmit}
          />
          <IconButton
            type='primary'
            size='big'
            icon='common-success-tick'
            title='time.form.tipSave'
            canHover={false}
            onClick={
              this.data.disableSubmit
                ? null
                : this._onFormSubmit.bind(this, false)
            }
            disabled={this.data.disableSubmit}
          />
        </div>
      </div>
    )
  }

  /* Event Handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onIncrementTime (incrValue) {
    const newTimeTaken = this._updateTimeTaken(this.state.time + incrValue)
    this.setState({
      timeText: this._formatTimeForInput(newTimeTaken),
      time: newTimeTaken
    })
  }

  _formatTimeForInput (timeTaken) {
    if (timeTaken === 0) {
      return '0:00'
    }

    return timeTaken ? Util.convertMinutesToHour(timeTaken) : ''
  }

  _updateTimeTaken (timeTaken) {
    timeTaken = timeTaken > 24 * 60 ? 24 * 60 : timeTaken
    return timeTaken
  }

  _onKeyPressInput (_ev) {}

  _onChangeTimeTaken (value) {
    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(value)) {
      this.forceUpdate()
    } else {
      let timeTaken = 0
      const timeArr = value.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }

      const newTimeTaken = this._updateTimeTaken(timeTaken)
      if (newTimeTaken !== timeTaken) {
        this.setState({
          time: this._formatTimeForInput(newTimeTaken),
          dataDate: new Date()
        })
      } else {
        this.setState({ timeText: value, time: newTimeTaken })
      }
    }
  }

  _onBlurTimeTaken () {
    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(this.state.timeText)) {
      this.forceUpdate()
    } else {
      let timeTaken = 0
      const timeArr = this.state.timeText.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }

      this.setState({
        timeText: this._formatTimeForInput(timeTaken),
        time: timeTaken
      })
    }
  }

  _onFormSubmit (bOpen, ev) {
    ev.preventDefault()

    if (!this.data.disableSubmit) {
      let noError = 0
      const timeObj = {
        timeTaken: this.state.time,
        description: this.state.description
      }

      if (this.state.activity) {
        // If normal activity
        timeObj.projectId = null
        timeObj.activityId = null
        timeObj.activity = this.state.activity
      } else if (!this.state.projectId || !this.state.activityId) {
        noError++
      } else {
        // If project and budgetitem set
        timeObj.projectId = this.state.projectId
        timeObj.activityId = this.state.activityId
        timeObj.activity = ''
        const budgetItem = _.find(
          this.data.activities,
          obj => obj.value === this.state.activityId
        )
        if (budgetItem) {
          timeObj.activity = budgetItem.label
        }
      }

      if (noError === 0) {
        this.data.disableSubmit = true
        this.setState({ dataDate: new Date() })

        if (this.props.onSubmit) {
          this.props.onSubmit(timeObj, bOpen)
        }
      }
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onChangeProject (projectId) {
    this.setState({ projectId: projectId })

    const extraQuery = {}
    const project = _.find(this.data.projects, obj => obj.value === projectId)

    if (project && project.activePhaseNos) {
      extraQuery.activePhaseNos = project.activePhaseNos
    }

    this.props.onSearchActivity(projectId, extraQuery, activities => {
      this.data.activities = activities
      this.forceUpdate()
    })
  }

  _onChangeBudgetItem (activityId) {
    this.setState({ activityId: activityId })
  }

  _onActivityClick (activity, e) {
    e.preventDefault()
    if (activity !== this.state.activity) {
      this.setState({ activity: activity })
    } else {
      this.setState({ activity: '' })
    }
  }

  /* Private Functions */
  _renderProjectActivty () {
    return (
      <div className='formrow'>
        <Select label='time.form.labelSelect' className='form-dropdown' />
      </div>
    )
  }

  _renderOtherActivity () {
    return (
      <div className='formrow'>
        <div className='activlist'>{this._renderActivities()}</div>
      </div>
    )
  }

  _renderActivities () {
    if (this.data.normalActivities && this.data.normalActivities.length > 0) {
      return this.data.normalActivities.map((activity, idx) => {
        let className = 'form-activities-item'
        if (activity.value === this.state.activity) {
          className = 'form-activities-item active'
        }

        return (
          <div
            className={className}
            key={idx}
            onClick={this._onActivityClick.bind(this, activity.value)}
          >
            <IntlMessage ident={activity.label} />
          </div>
        )
      })
    }

    return ''
  }
}

export default MobileForm
